export const en: Record<string, string> = {
  // Nav & System Drawer
  'nav.dashboard': 'Dashboard',
  'nav.focus': 'Daily Focus & Roadmap',
  'nav.ai_assistant': 'Automated Operational Engine',
  'nav.calendar': 'Google Calendar',
  'nav.book': 'Public Booking Page',
  'nav.bookings': 'Bookings',
  'nav.invoices': 'Invoices',
  'nav.expenses': 'Expenses',
  'nav.settings': 'Business & Tax HQ',
  'nav.billing': 'Subscription & Plans',
  'nav.j_lens': 'J-Lens Vault',
  'nav.concept': 'Concept & Mindset',
  'nav.what_is': 'What is AzuraOS?',
  'nav.export': 'Export & Backup',
  'nav.menu': 'Menu',
  'nav.welcome': 'Welcome & BYOK Hub',
  'nav.app_stack_modules': 'App Stack Modules',
  'nav.core_engines': '8 Core Engines',
  'nav.manifesto': 'Founder System & Manifesto',
  'nav.workspace_actions': 'Workspace Actions',
  'nav.export_records': 'Export Records',
  'nav.load_demo': 'Load Demo Sandbox',
  'nav.partnerships': 'Partnerships & Backing',
  'nav.request_partnership': 'Request Partnership Access',
  'nav.partner_subtext': 'Bank integrations, ESD cohorts & sponsorships',
  'nav.interface_language': 'Interface Language',
  'nav.legal_trust': 'Legal & Trust',
  'nav.security': 'Security',
  'nav.faqs': 'FAQs',
  'nav.terms': 'Terms',
  'nav.privacy': 'Privacy',
  'nav.refund': 'Refund Policy',
  'nav.contact': 'Contact',
  'nav.report_bug': 'Report Bug',
  'nav.invite_founder': '+ Invite Founder',
  'nav.privacy_active': 'Public Privacy Mode: ACTIVE',
  'nav.privacy_off': 'Public Privacy Mode: OFF',
  'nav.masked': 'Masked',
  'nav.visible': 'Visible',
  'nav.live_margin': 'LIVE OPERATIONAL MARGIN',
  'nav.target_safe_zone': 'Safe Zone Target:',
  'nav.close_menu': 'Close Menu',
  'nav.founder_access': 'Sign In / Founder Access',
  'nav.private_vault': 'Private Vault Connected',
  'nav.master_access': 'Master Founder Access',
  'nav.lifetime': 'Lifetime',
  'nav.pro_active': 'Sovereign Pro Active',
  'nav.trial_days': '7-Day Trial: {days} days left',
  'nav.trial_expired': 'Trial Expired',
  'nav.manage': 'Manage →',
  'nav.upgrade': 'Upgrade →',
  'nav.unlock_pro': 'Unlock Pro →',

  // Dashboard Cards & Sections
  'dash.greeting_morning': 'Good morning',
  'dash.greeting_afternoon': 'Good afternoon',
  'dash.greeting_evening': 'Good evening',
  'dash.value_prop': 'Multi-Stream Control in One Place: Enter 1 income stream and 1 expense to see your net profit margin live adjust in real time.',
  'dash.manage_streams': 'Manage Income Streams',
  'dash.close_streams': 'Close Streams',
  'dash.income': 'Income',
  'dash.collected': 'Collected',
  'dash.unpaid': 'Unpaid',
  'dash.expenses': 'Expenses',
  'dash.across_records': 'Across records',
  'dash.net_profit': 'Net Profit',
  'dash.daily_focus_title': 'Daily Focus & Revenue Action Plan',
  'dash.daily_focus_sub': 'High-leverage founder tasks driving profit and growth',
  'dash.open_focus': 'Open Focus Roadmap',
  'dash.stream_profitability': 'Stream Profitability',
  'dash.stream_sub': '1 offer or multiple streams • Live margin tracking',
  'dash.quick_actions': 'Quick Actions',
  'dash.add_booking': 'Add Booking',
  'dash.add_booking_desc': 'Record a new client stream',
  'dash.add_expense': 'Add Expense',
  'dash.add_expense_desc': 'Log business/operations costs',
  'dash.add_insight': 'Add Insight',
  'dash.add_insight_desc': 'Capture a new J-Lens rule',
  'dash.quick_add_title': 'Quick Add (Inline)',
  'dash.quick_revenue': '+ QUICK REVENUE (BOOKING)',
  'dash.quick_expense': '+ QUICK EXPENSE (LEDGER)',
  'dash.recent_activity': 'Recent Activity',
  'dash.no_activity': 'No recent activity recorded yet. Use the Quick Actions above to begin.',
  'dash.spotlight_insight': 'Spotlight J-Lens Insight',
  'dash.access_vault': 'Access Vault →',
  'dash.sandbox_active': 'Sandbox Active',
  'dash.load_demo_data': 'Load Demo Data',
  'dash.clear_sandbox': 'Clear Sandbox',
  'dash.clear_confirm': 'Clear data?',
  'dash.yes_clear': 'Yes, clear',
  'dash.cancel': 'Cancel',

  // Bookings View
  'bookings.title': '📅 Bookings & Streams',
  'bookings.subtitle': 'Sovereign client income channels',
  'bookings.public_page': 'Public Booking Page',
  'bookings.import_csv': 'Import CSV',
  'bookings.add_button': 'Add Booking',
  'bookings.client_link_title': 'Client Self-Scheduling Link',
  'bookings.client_link_desc': 'Share standard or custom-priced scheduling links with clients to auto-book and sync Google Calendar.',
  'bookings.link_active': 'Active',
  'bookings.generate_custom_link': '⚡ Generate Custom Price Link',
  'bookings.hide_custom_link': 'Hide Custom Quote Link',
  'bookings.copy_standard_link': 'Copy Standard Link',
  'bookings.copied_link': 'Copied Link!',
  'bookings.preview': 'Preview',
  'bookings.search_placeholder': 'Search by client or stream...',
  'bookings.filter_all': 'All Streams',
  'bookings.table_client': 'Client Name',
  'bookings.table_stream': 'Stream / Service',
  'bookings.table_date': 'Date',
  'bookings.table_amount': 'Amount',
  'bookings.table_status': 'Status',
  'bookings.table_actions': 'Actions',
  'bookings.mark_paid': 'Mark Paid',
  'bookings.mark_unpaid': 'Mark Unpaid',
  'bookings.delete': 'Delete',
  'bookings.no_records': 'No client bookings found. Use "Add Booking" or the public scheduling link above.',

  // Invoices View
  'invoices.title': '📄 Client Invoices & Receivables',
  'invoices.subtitle': 'Professional client invoicing & payment reconciliation',
  'invoices.create_invoice': 'Create New Invoice',
  'invoices.tab_all': 'All Invoices',
  'invoices.tab_paid': 'Paid Invoices',
  'invoices.tab_outstanding': 'Outstanding / Pending',
  'invoices.tab_overdue': 'Overdue',
  'invoices.table_number': 'Invoice #',
  'invoices.table_client': 'Client',
  'invoices.table_issue_date': 'Issue Date',
  'invoices.table_due_date': 'Due Date',
  'invoices.table_total': 'Total Amount',
  'invoices.table_status': 'Status',
  'invoices.download_pdf': 'Download PDF',
  'invoices.mark_as_paid': 'Mark Paid',
  'invoices.no_records': 'No invoices generated yet. Create an invoice to track receivables.',

  // Expenses View
  'expenses.title': '💳 Business Expenses & Ledger',
  'expenses.subtitle': 'Sovereign outflow tracking & tax deduction optimization',
  'expenses.log_expense': 'Log Expense',
  'expenses.import_csv': 'Import CSV',
  'expenses.total_outflow': 'Total Outflows',
  'expenses.tax_deductible': 'Tax Deductible',
  'expenses.search_placeholder': 'Search by vendor or description...',
  'expenses.filter_all': 'All Categories',
  'expenses.table_category': 'Category',
  'expenses.table_description': 'Description / Vendor',
  'expenses.table_date': 'Date',
  'expenses.table_claimable': 'Tax Claimable',
  'expenses.table_amount': 'Amount',
  'expenses.table_actions': 'Actions',
  'expenses.claimable_yes': 'Yes (Deductible)',
  'expenses.claimable_no': 'No (Personal/Disallowed)',
  'expenses.no_records': 'No expenses recorded yet. Log your business costs to calculate real net margins.',

  // Daily Focus & Roadmap
  'focus.title': '🎯 Daily Focus & Revenue Action Plan',
  'focus.subtitle': 'High-leverage founder tasks driving profit, client flow, and strategic momentum',
  'focus.add_task': 'Add Revenue Task',
  'focus.active_tasks': 'Active Priority Tasks',
  'focus.completed_tasks': 'Completed Tasks',
  'focus.high_leverage': 'High Leverage',
  'focus.mark_done': 'Mark Complete',
  'focus.delete_task': 'Delete',
  'focus.no_tasks': 'All clear! Add a high-leverage revenue task to maintain momentum.',

  // Automated Operational Engine
  'ai.title': '⚡ Automated Operational Engine',
  'ai.subtitle': 'Client-side encrypted calculations & sovereign operational intelligence (Zero Data Retention)',
  'ai.ask_placeholder': 'Ask your Operational Engine about cash flow, margin optimization, or pricing strategy...',
  'ai.send': 'Analyze',
  'ai.thinking': 'Operational Engine is processing your financial calculations...',
  'ai.prompt_margin': 'How can I increase my net profit margin to 60%?',
  'ai.prompt_tax': 'What expenses should I claim to optimize tax buffer?',
  'ai.prompt_pricing': 'How should I structure tiered retainer packages?',
  'ai.clear_chat': 'Clear History',

  // Business & Tax HQ
  'hq.title': '🏢 Business & Tax HQ',
  'hq.subtitle': 'Profile, currency, statutory tax rules, jurisdiction presets & audit exports',
  'hq.tab_profile': 'Profile & Identity',
  'hq.tab_currency_tax': 'Currency & Tax Rules',
  'hq.tab_accountant_view': 'Accountant & CPA Audit View',
  'hq.tab_exports': 'Data Exports & Backups',
  'hq.tab_security': 'Security Safeguards',
  'hq.jurisdiction_preset_title': 'Regional Jurisdiction Preset',
  'hq.jurisdiction_preset_desc': 'Select your operating country to auto-configure local currency, VAT/GST tax rules, and official tax authority labels.',
  'hq.accountant_view_title': 'Accountant & CPA Audit View',
  'hq.accountant_view_desc': 'Standardized pre-accounting summary and audit pack ready for external CPAs, tax accountants, or bank underwriting.',
  'hq.export_pdf_audit': 'Printable PDF CPA Audit Statement',
  'hq.export_csv_audit': 'Export CPA Audit CSV',
  'hq.currency_symbol': 'Currency Symbol',
  'hq.currency_code': 'Currency Code',
  'hq.vat_rate': 'VAT / GST Rate (%)',
  'hq.tax_authority': 'Tax Authority Name',
  'hq.save_settings': 'Save Business Settings',

  // Financial & Metric Labels
  'metric.gross_revenue': 'Gross Revenue',
  'metric.total_expenses': 'Total Expenses',
  'metric.net_profit': 'Net Operating Income',
  'metric.profit_margin': 'Operating Profit Margin',
  'metric.active_bookings': 'Active Bookings',
  'metric.paid_invoices': 'Paid Invoices',
  'metric.unpaid_invoices': 'Unpaid / Overdue',
  'metric.tax_buffer': 'Estimated Tax Buffer',
  'metric.currency': 'Operating Currency',
  'metric.tax_rate': 'VAT / Tax Rate',

  // Actions & Common Buttons
  'btn.save': 'Save Changes',
  'btn.cancel': 'Cancel',
  'btn.download': 'Download',
  'btn.export_pdf': 'Download Report as PDF',
  'btn.export_csv': 'Export as CSV',
  'btn.cpa_pack': 'Export Accountant Pack',
  'btn.new_booking': 'Record Booking',
  'btn.new_expense': 'Log Expense',
  'btn.add_task': 'Add Focus Task',
  'btn.sync_calendar': 'Sync Google Calendar',
  'btn.privacy_mode': 'Privacy Mode',
  'btn.manage_subscription': 'Manage Subscription',
  'btn.sign_in': 'Sign In / Founder Access',
  'btn.sign_out': 'Sign Out',
  'btn.delete': 'Delete',
  'btn.edit': 'Edit',
  'btn.close': 'Close',

  // Statuses
  'status.paid': 'Paid',
  'status.unpaid': 'Unpaid',
  'status.overdue': 'Overdue',
  'status.safe': 'Healthy Margin',
  'status.warning': 'Margin Alert',
  'status.trial_active': 'Free Trial Active',
  'status.pro_active': 'Sovereign Pro',
};
